<div class="layout-footer footer-elements flex-row-reverse">
	<div class="copy">
		Copyright &copy; 2012-{{ currentYear }} Hellenic Enterprise Solutions GP.
		All rights reserved.
		Licensed to Mikroskopisi Medical Labs Group.
		Biorec &copy; is a registered trademark of Hellenic Enterprise Solutions GP.
	</div>
</div>